import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, Download, Printer } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-warm-white pt-8 pb-16 px-6 md:pt-14 md:pb-24" data-id="element-35">
      <div className="max-w-reading mx-auto" data-id="element-36">
        {/* Headline & Subhead FIRST */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-37">
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-6 leading-tight" data-id="element-38">
            Stop the 2 AM Bathroom March.
          </h1>
          <p className="text-xl md:text-2xl text-charcoal/80 font-serif italic" data-id="element-39">
            Sleep a full block again — without "no water" rules.
          </p>
        </motion.div>

        {/* Product Image SECOND */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.7
      }} className="mb-10 flex justify-center" data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/eaeiA9xEHpLhgxY32Yqn21/heylloyd-image-1771004141966.jpg" alt="The Quiet Bladder Reset on a tablet" className="w-80 md:w-[420px] rounded-xl shadow-[0_12px_40px_-6px_rgba(28,42,58,0.22)] border border-border-gray/60" data-id="element-41" />
        </motion.div>

        {/* First CTA THIRD */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="text-center mb-16" data-id="element-42">
          <button onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} className="w-full md:w-auto bg-amber hover:bg-amber-hover text-white text-xl font-bold py-4 px-8 rounded-lg shadow-md transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 mx-auto" data-id="element-43">
            Get the Reset — $6.36 <ArrowRight className="w-6 h-6" data-id="element-44" />
          </button>
          <div className="mt-4 flex flex-wrap justify-center gap-4 text-sm text-charcoal/70" data-id="element-45">
            <span className="flex items-center gap-1" data-id="element-46">
              <Download className="w-4 h-4" data-id="element-47" /> Instant download
            </span>
            <span className="hidden md:inline" data-id="element-48">•</span>
            <span className="flex items-center gap-1" data-id="element-49">
              <Printer className="w-4 h-4" data-id="element-50" /> Printable tracker included
            </span>
            <span className="hidden md:inline" data-id="element-51">•</span>
            <span className="flex items-center gap-1" data-id="element-52">
              <Lock className="w-4 h-4" data-id="element-53" /> Private, no embarrassment
            </span>
          </div>
        </motion.div>

        {/* Prose FOURTH */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="prose prose-lg text-charcoal text-lg md:text-xl leading-relaxed space-y-6" data-id="element-54">
          <p data-id="element-55">It's not the peeing that breaks you.</p>

          <p data-id="element-56">
            It's the math your brain does at 2:07 AM — half awake — before your
            feet even hit the floor.
          </p>

          <div className="pl-6 border-l-4 border-sage/30 italic text-charcoal/90 my-8 space-y-2" data-id="element-57">
            <p data-id="element-58">"How many times tonight?"</p>
            <p data-id="element-59">"Will I get back to sleep?"</p>
            <p data-id="element-60">"Is this just what aging feels like now?"</p>
          </div>

          <p data-id="element-61">And the worst part?</p>
          <p data-id="element-62">Most advice is either useless… or insulting.</p>

          <div className="pl-6 border-l-4 border-sage/30 italic text-charcoal/90 my-8 space-y-2" data-id="element-63">
            <p data-id="element-64">"Stop drinking water."</p>
            <p data-id="element-65">"Just do Kegels."</p>
            <p data-id="element-66">"Try this supplement."</p>
          </div>

          <p data-id="element-67">So you do the obvious thing: you start cutting water.</p>
          <p data-id="element-68">
            And somehow you sleep worse — thirsty, irritated, waking anyway.
          </p>
        </motion.div>

        {/* Transition Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-12 mb-12 bg-warm-gray/50 p-8 rounded-xl border border-border-gray" data-id="element-69">
          <p className="text-lg md:text-xl leading-relaxed font-medium text-charcoal" data-id="element-70">
            The Quiet Bladder Reset is a different approach:
            <br data-id="element-71" />
            <br data-id="element-72" />
            A simple evening protocol + a 3-minute tracker that helps you
            identify the real driver behind your night wake-ups — so you can
            sleep a full block again.
            <br data-id="element-73" />
            <br data-id="element-74" />
            No hype. No embarrassment. No willpower contest.
            <br data-id="element-75" />
            Just a plan you can run tonight.
          </p>
        </motion.div>
      </div>
    </section>;
}